import styled, { css } from 'styled-components'
import Card from '@components/HowItWorks/Card'
import Box from '@components/Box'
import { above, below } from '@styles/mixins/breakpoints'

export const SCard = styled(Card)``

export const SColumn = styled(Box)`
  ${SCard}:not(:last-child) {
    margin-bottom: 16px;
  }
  ${above('md')(css`
    display: flex;
    justify-content: space-between;
    width: 100%;

    ${SCard}:not(:last-child) {
      margin-bottom: 0;
    }
  `)}

  ${above('xl')(css`
    display: block;
    width: auto;
    ${SCard}:not(:last-child) {
      margin-bottom: 12px;
    }
  `)}
`

export const SSingleColumn = styled(SColumn)`
  justify-content: center;
  ${above('md')(css`
    margin: 80px 0;
  `)}
  ${above('xl')(css`
    margin: 0;
  `)}
`

export const SList = styled.ul<{compact?: boolean}>`
  margin: 0;
  padding-left: 20px;

  & > li {
    color: white;
    margin-bottom: ${({compact}) => compact ? '5px' : '15px'};
    font-size: 12px;
    line-height: 16px;
  }
`

export const SShortCard = styled(SCard)`
  ${below('md')(css`
    width: 228px;
  `)}
`
